module.exports = __webpack_public_path__ + "img/2.e8617d09.png";